import {FiMessageCircle, FiUsers, FiBriefcase, FiLayout, FiHome } from 'react-icons/fi'

export const menus = [
    {symbol: <FiHome />, title:'Home', url:'/home'},
    {symbol: <FiBriefcase />, title:'Projects', url:'/projects'},
    {symbol: <FiUsers />, title:'Users', url:'/users'},
    {symbol: <FiLayout />, title:'Profile', url:'/profile'},
    {symbol: <FiMessageCircle />, title:'Chat', url:'/chat'},
]
export const menusGuest = [
    {symbol: <FiHome />, title:'Home', url:'/home'},
    {symbol: <FiBriefcase />, title:'Projects', url:'/projects'},
    {symbol: <FiUsers />, title:'Users', url:'/users'},
    {symbol: <FiMessageCircle />, title:'Chat', url:'/chat'},
]
export const menuAuth = [
    {symbol: <FiBriefcase />, title:'Projects', url:'/projects'},
    {symbol: <FiUsers />, title:'Users', url:'/users'},
    {symbol: <FiLayout />, title:'Profile', url:'/profile'}
]

export const user = { avatar:null, name:'Tester Test', email:'test@test.com' }


export const groups = ['People', 'Companies', 'Groups']

export const usersResult = [
    {name:'Cecile Vuillet', bio:'Principal designer at Ulysse & Ulysses',image:13, type:'2nd'},
    {name:'Adelle Vuillard', bio:'Sales VP at John Lewis',image:14, type:'2nd'},
    {name:'Angel Vuillin', bio:'Consultant maketing Taylor and co',image:11, type:'2nd'},
    {name:'Karen Vuillemot', bio:'Fitness specialist at Nuffield Health',image:12, type:'2nd'},
];
